export default __webpack_public_path__ + "static/media/front_lever.aedcd319.svg";